module.exports = __webpack_public_path__ + "static/media/quotearrow.f1e5704a.svg";